import React from 'react';
import '../styles/App.css';

// ANDROID WECHAT SPLASH
import androidSplash from '../images/en-android-breakout-wechat.png';
import androidSplashCN from '../images/cn-android-breakout-wechat.png';

// IOS WECHAT SPLASH
import iOSSplash from '../images/en-ios-breakout-wechat.png';
import iOSSplashCN from '../images/cn-ios-breakout-wechat.png';

let tr = require( '../utils/translations' ).translate,
	splashImage;

if ( /iPad|iPhone|iPod/.test( navigator.userAgent || navigator.vendor || window.opera ) && !window.MSStream )
	splashImage = tr( iOSSplash, iOSSplashCN );

else splashImage = tr( androidSplash, androidSplashCN );


// MAIN REACT CLASS DECLARATION
// =================================================================================================
class SplashComponent extends React.Component {


	// REACT APP CONSTRUCTOR
	// =============================================================================================
	constructor( props ) {

		super( props );

		window.mixpanel.track( 'Pageview', {
			app: 'video-to-gif',
			action: 'mobile-splash'
		} )
	}


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {

		// CHECK FOR WECHAT BROWSER
		return (
			<div id="splashPanel" className="splash-wechat">
				<img src={splashImage}/>
			</div>
		);
	}
}

export default SplashComponent;


// WEBPACK FOOTER //
// ./src/app/scenes/mobile.js